import React, {Component, PropTypes} from 'react'
import GetStartedWidget from './GetStartedWidget'
import bookmakers from 'config/bookmakers'
import {Modal} from 'react-bootstrap'
import { editList } from 'actions/bookmakerLists'



export default class BookmakerIntro extends Component {

  constructor(props) {
    super(props)
    this.state = {
      showModal:false,
      selectedBookmakers: {}
    }
    this.onClose = this.onClose.bind(this)
    this.onOpen = this.onOpen.bind(this)
    this.addBookmakersToList = this.addBookmakersToList.bind(this)
  }

  onClose() {
    this.setState({
      showModal:false
    })
  }

  onOpen() {
    this.setState({
      showModal:true
    })
  }

  componentDidMount() {
    window.analytics.track('Get started', {
      index: 1
    })
    this.setState({
      selectedBookmakers: this.props.bookmakerList.bookmakers
    })
  }

  bookmakerClick(key) {
    if(this.state.selectedBookmakers[key] === true) {
      delete this.state.selectedBookmakers[key]
      this.setState({
        selectedBookmakers: this.state.selectedBookmakers
      })
    }
    else {
      this.state.selectedBookmakers[key] = true
      this.setState({
        selectedBookmakers: this.state.selectedBookmakers
      })
    }
  }

  addBookmakersToList() {
    const {dispatch} = this.props
    dispatch(editList(this.props.listId, {
      bookmakers:this.state.selectedBookmakers}))
    this.setState({
      showModal:false
    })

  }

  render() {
    return (
      <GetStartedWidget heading="Let's add some bookmakers." content='In order for us to show you edgebets, you need to have some bookmakers. We have already recommended some bookmakers for you. Does these work for you?'>
          <Modal show={this.state.showModal} onHide={this.onClose}>
            <Modal.Header closeButton>
              <Modal.Title>Edit Bookmakers</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {Object.keys(bookmakers).map(key=> {
                if(this.state.selectedBookmakers[key] === true) {
                  return (<div key={key} className='bookmaker selected' onClick={this.bookmakerClick.bind(this, key)}> {bookmakers[key]} </div>)
                }
                else {
                  return (
                    <div key={key} className='bookmaker' onClick={this.bookmakerClick.bind(this, key)}> {bookmakers[key]} </div>
                  )
                }

              })}
              <button className='btn btn-success' onClick={this.addBookmakersToList}> Save </button>
            </Modal.Body>
          </Modal>
          <div className='bookmakerContainer'>
            {Object.keys(this.props.bookmakerList.bookmakers).map(key=> {
              return (<div key={key} className='bookmaker'> {bookmakers[key]}</div>)
            })}
          </div>
          <button className='btn btn-primary' onClick={this.onOpen}> I'd like to change them </button>
          <button className='btn btn-success' onClick={this.props.onComplete}>Looks great</button>
      </GetStartedWidget>
      )
  }
}

BookmakerIntro.propTypes = {
  onComplete:PropTypes.func.isRequired,
  bookmakerList:PropTypes.object.isRequired,
  listId:PropTypes.string.isRequired
}



/** WEBPACK FOOTER **
 ** ./src/components/getstarted/BookmakerIntro.js
 **/